import { render, staticRenderFns } from "./RouteItinerary.vue?vue&type=template&id=4f4baca2&scoped=true"
import script from "./RouteItinerary.vue?vue&type=script&lang=js"
export * from "./RouteItinerary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4baca2",
  null
  
)

export default component.exports